const AccountConfig = {
  accountForm: {
    render(createElement) {
      return createElement('div', 'Account form component is not provided.')
    },
  },

  textMenuSettings: 'Account settings',
}

export default AccountConfig
